export const RESET_ERROR = 'vehicles/RESET_ERROR';

export const FETCH_VEHICLE_MAKE_FAIL = 'vehicles/FETCH_VEHICLE_MAKE_FAIL';
export const FETCH_VEHICLE_MAKE_SUCCESS = 'vehicles/FETCH_VEHICLE_MAKE_SUCCESS';
export const FETCH_VEHICLE_MODEL_FAIL = 'vehicles/FETCH_VEHICLE_MODEL_FAIL';
export const FETCH_VEHICLE_MODEL_SUCCESS = 'vehicles/FETCH_VEHICLE_MODEL_SUCCESS';
export const FETCH_VEHICLE_GENERATION_FAIL = 'vehicles/FETCH_VEHICLE_GENERATION_FAIL';
export const FETCH_VEHICLE_GENERATION_SUCCESS = 'vehicles/FETCH_VEHICLE_GENERATION_SUCCESS';
export const FETCH_VEHICLE_MODIFICATION_FAIL = 'vehicles/FETCH_VEHICLE_MODIFICATION_FAIL';
export const FETCH_VEHICLE_MODIFICATION_SUCCESS = 'vehicles/FETCH_VEHICLE_MODIFICATION_SUCCESS';

export const FETCH_CLIENT_VEHICLES = 'vehicles/FETCH_CLIENT_VEHICLES';
export const FETCH_CLIENT_VEHICLES_FAIL = 'vehicles/FETCH_CLIENT_VEHICLES_FAIL';
export const FETCH_CLIENT_VEHICLES_SUCCESS = 'vehicles/FETCH_CLIENT_VEHICLES_SUCCESS';
export const FETCH_CLIENT_VEHICLE = 'vehicles/FETCH_CLIENT_VEHICLE';
export const FETCH_CLIENT_VEHICLE_FAIL = 'vehicles/FETCH_CLIENT_VEHICLE_FAIL';
export const FETCH_CLIENT_VEHICLE_SUCCESS = 'vehicles/FETCH_CLIENT_VEHICLE_SUCCESS';
export const CREATE_CLIENT_VEHICLE = 'vehicles/CREATE_CLIENT_VEHICLE';
export const CREATE_CLIENT_VEHICLE_FAIL = 'vehicles/CREATE_CLIENT_VEHICLE_FAIL';
export const CREATE_CLIENT_VEHICLE_SUCCESS = 'vehicles/CREATE_CLIENT_VEHICLE_SUCCESS';
export const UPDATE_CLIENT_VEHICLE = 'vehicles/UPDATE_CLIENT_VEHICLE';
export const UPDATE_CLIENT_VEHICLE_FAIL = 'vehicles/UPDATE_CLIENT_VEHICLE_FAIL';
export const UPDATE_CLIENT_VEHICLE_SUCCESS = 'vehicles/UPDATE_CLIENT_VEHICLE_SUCCESS';
export const DELETE_CLIENT_VEHICLE_FAIL = 'vehicles/DELETE_CLIENT_VEHICLE_FAIL';
export const DELETE_CLIENT_VEHICLE_SUCCESS = 'vehicles/DELETE_CLIENT_VEHICLE_SUCCESS';
export const MAKE_CLIENT_VEHICLE_PRIMARY = 'vehicles/MAKE_CLIENT_VEHICLE_PRIMARY';
export const MAKE_CLIENT_VEHICLE_PRIMARY_FAIL = 'vehicles/MAKE_CLIENT_VEHICLE_PRIMARY_FAIL';
export const MAKE_CLIENT_VEHICLE_PRIMARY_SUCCESS = 'vehicles/MAKE_CLIENT_VEHICLE_PRIMARY_SUCCESS';

export const CLEAR_CLIENT_VEHICLES_SUCCESS = 'vehicles/CLEAR_CLIENT_VEHICLES_SUCCESS';
export const CLEAR_CLIENT_VEHICLE_SUCCESS = 'vehicles/CLEAR_CLIENT_VEHICLE_SUCCESS';

export const FIND_VEHICLE = 'clients/FIND_VEHICLE';
export const FIND_VEHICLE_SUCCESS = 'clients/FIND_VEHICLE_SUCCESS';
export const FIND_VEHICLE_FAIL = 'clients/FIND_VEHICLE_FAIL';
export const CLEAR_FOUNDED_VEHICLE = 'vehicles/CLEAR_FOUNDED_VEHICLE';

export const ADD_VEHICLE_TO_CLIENT_SUCCESS = 'vehicles/ADD_VEHICLE_TO_CLIENT_SUCCESS';
export const ADD_VEHICLE_TO_CLIENT_FAIL = 'vehicles/ADD_VEHICLE_TO_CLIENT_FAIL';

export const GET_CARMEN_VEHICLE = 'vehicles/GET_CARMEN_VEHICLE';
export const GET_CARMEN_VEHICLE_SUCCESS = 'vehicles/GET_CARMEN_VEHICLE_SUCCESS';
export const GET_CARMEN_VEHICLE_FAIL = 'vehicles/GET_CARMEN_VEHICLE_FAIL';
export const UPDATE_CARMEN_VEHICLE_SUCCESS = 'vehicles/UPDATE_CARMEN_VEHICLE_SUCCESS';
export const UPDATE_CARMEN_VEHICLE_FAIL = 'vehicles/UPDATE_CARMEN_VEHICLE_FAIL';
